import React from "react";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { DateHelper } from "../../../../../../react-core/Helpers/DateHelper";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { MultiselectDropdown } from "../../../../../../react-core/Html/Components/MultiselectDropdown";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { AlphanumericWithSpace } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { CompanySearchClient } from "../../../../../../Wrap/Api/Company/CompanySearch";
import { NetworkHistoryClient } from "../../../../../../Wrap/Api/Network/NetworkHistory";
import { CompanyDetailSort } from "../../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { ThreadType } from "../../../../../../Wrap/Constants/Enums/Domain/ThreadType";
import { NetworkType } from "../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { AlertDefinition } from "../../../../../../Wrap/Models/Domains/Threads/AlertDefinition";
import { AlertDefinitionCategory } from "../../../../../../Wrap/Models/Domains/Threads/AlertDefinitionCategory";
import { ClientNotificationFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { AdviserWizardAction } from "../../../../../Admin/Adviser/Actions/AdviserWizardAction";
import { SearchInput } from "../../../../../Shared/SearchInput/SearchInput";
import { titleLabels } from "../../../Clients/AddClient/Resource/Contents";
import { NotificationAction } from "../../Action/NotificationAction";
import {
    EventTypeMap,
    EventTypeOptions,
    NotificationDateRangeTypeOptions,
    NotificationDateRangeTypeMap,
} from "../../Resource/Content";
import { NotificationFilterStore } from "../../Store/Variable";

interface INotificationFilterFormProps {
    currentFilter: ClientNotificationFiltersModel;
    isLightbox: boolean;
    onRef: (ref) => void;
}

interface INotificationFilterFormState {
    filter: ClientNotificationFiltersModel;
    alertDefinitionCategories: Array<AlertDefinitionCategory>;
    alertDefinitions: Array<AlertDefinition>;
    displayNetworkSearch: boolean;
    displayCompanySearch: boolean;
    availableAdvisors: Array<Adviser>;
    selectedNetwork: NetworkHistoryModel;
    selectedCompany: CompanySummary;
}

export class NotificationFilterForm extends FormComponent<INotificationFilterFormProps, INotificationFilterFormState> {
    constructor(props: INotificationFilterFormProps) {
        super(props);
        this.state = {
            filter: JSON.parse(JSON.stringify(props.currentFilter)),
            alertDefinitionCategories: [],
            alertDefinitions: [],
            displayNetworkSearch: null,
            displayCompanySearch: null,
            availableAdvisors: [],
            selectedCompany: null,
            selectedNetwork: null,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        NotificationAction.getNotificationDefinitionCategories((result) => {
            this.setState({ alertDefinitionCategories: result });
        });

        NotificationAction.getNotificationDefinitions((result) => {
            this.setState({ alertDefinitions: result });
        });

        this.getNetworksAndCompanies();
    }

    getData = () => {
        return this.state.filter;
    };

    private getNetworksAndCompanies() {
        if (this.state.selectedCompany || this.state.selectedNetwork) {
            this.getAdviser(this.state.selectedNetwork?.Network, this.state.selectedCompany?.CompanyCode);
        }

        const networkClient = new NetworkHistoryClient();
        const companyClient = new CompanySearchClient();
        if (!CommonHelper.isNullOrEmpty(this.props.currentFilter?.Network)) {
            networkClient
                .get(this.props.currentFilter.Network, NetworkType.Network, null, null, null, false, 10, 1)
                .onSuccess((result) => {
                    this.setState({ selectedNetwork: result[0] });
                });
        }
        if (!CommonHelper.isNullOrEmpty(this.props.currentFilter?.CompanyCode)) {
            companyClient
                .get(
                    this.props.currentFilter?.CompanyCode,
                    null,
                    FirmType.All,
                    null,
                    null,
                    null,
                    true,
                    1,
                    10,
                    CompanyDetailSort.CompanyName,
                    false
                )
                .onSuccess((result) => {
                    this.setState({ selectedNetwork: result[0] });
                });
        }
        networkClient.get(null, NetworkType.Network, null, null, null, false, 10, 1).onSuccess((result) => {
            if (result.TotalRows > 1) {
                this.setState({ displayNetworkSearch: true });
            } else {
                this.setState({ displayNetworkSearch: false });
            }
        });

        companyClient
            .get(null, null, FirmType.All, null, null, null, true, 1, 10, CompanyDetailSort.CompanyName,false)
            .onSuccess((result) => {
                if (result.TotalNumberOfResults > 1) {
                    this.setState({ displayCompanySearch: true });
                } else if (result.TotalNumberOfResults == 1) {
                    this.getAdviser(null, result.PageOfResults[0].CompanyCode);
                    this.setState({ selectedCompany: result.PageOfResults[0], displayCompanySearch: false });
                }
            });
    }

    private getAdviser(network, company) {
        if (CommonHelper.isNullOrEmpty(company) && CommonHelper.isNullOrEmpty(network)) {
            this.setState({ availableAdvisors: [] });
        } else {
            AdviserWizardAction.getAdviser(
                { Company: company, Network: network, CurrentPage: 1, ResultsPerPage: 999 },
                (result) => {
                    this.setState({
                        availableAdvisors: result.Results,
                    });
                }
            );
        }
    }

    public render() {
        const { alertDefinitionCategories, filter, alertDefinitions } = this.state;

        const networkClient = new NetworkHistoryClient();
        const companyClient = new CompanySearchClient();

        let notificationOptions = alertDefinitions.filter((x) => x.CategoryId == filter?.EventCategoryId);
        if (filter?.EventType != ThreadType.NotSpecified) {
            notificationOptions = notificationOptions.filter((x) => x?.Type == EventTypeMap[filter?.EventType]);
        }

        return (
            <div>
                <div className="row">
                    <div className="col-auto">
                        {this.props.isLightbox && (
                            <TextBoxEditor
                                placeholder=""
                                label="Filter name"
                                value={filter?.FilterName}
                                maxLength={60}
                                required={"Please enter filter name"}
                                infoText={
                                    this.state.filter?.FilterName?.length < 60
                                        ? `${60 - this.state.filter?.FilterName?.length} characters remaining`
                                        : null
                                }
                                regex={{
                                    value: AlphanumericWithSpace,
                                    errorMessage: "only allow alpha and numeric character!",
                                }}
                                onChange={(v) => {
                                    const _data = { ...this.state?.filter };
                                    _data.FilterName = v;
                                    this.setState(() => ({
                                        filter: _data,
                                    }));
                                }}
                            />
                        )}
                    </div>
                </div>

                <div className="row">
                    {this.state.displayNetworkSearch && (
                        <div className="col-12 col-md-4">
                            <SearchInput
                                apiClient={(v) => {
                                    return networkClient.get(null, NetworkType.Unknown, v, null, null, false, 20, 1);
                                }}
                                onClick={(v) => {
                                    if (!v) {return;}
                                    this.getAdviser(v?.Network, null);
                                    this.setState({
                                        selectedNetwork: v,
                                        selectedCompany: null,
                                        filter: { ...this.state.filter, Network: v?.Network, AdviserIds: [] },
                                    });
                                }}
                                resultKey="networks"
                                getText={(v: NetworkHistoryModel) => v.NetworkName}
                                cssWrapper="control-size-430"
                                label={titleLabels.networkLabel}
                                value={this.state.selectedNetwork?.NetworkName}
                            />
                        </div>
                    )}
                    {this.state.displayCompanySearch && (
                        <div className="col-12 col-md-4">
                            <SearchInput
                                apiClient={(v) => {
                                    return companyClient.get(
                                        null,
                                        v,
                                        FirmType.All,
                                        null,
                                        this.state.selectedNetwork?.Network,
                                        null,
                                        true,
                                        1,
                                        20,
                                        CompanyDetailSort.CompanyName,
                                        false
                                    );
                                }}
                                resultKey={"PageOfResults"}
                                onClick={(v) => {
                                    if (!v) {return;}
                                    this.getAdviser(this.state.selectedNetwork?.Network, v?.CompanyCode);
                                    this.setState({
                                        selectedCompany: v,
                                        filter: { ...this.state.filter, CompanyCode: v?.CompanyCode, AdviserIds: [] },
                                        availableAdvisors: [],
                                    });
                                }}
                                getText={(v: CompanySummary) => v.CompanyName}
                                cssWrapper="control-size-430"
                                label={titleLabels.firmLabel}
                                value={this.state.selectedCompany?.CompanyName}
                            />
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className="col-12 col-md-4">
                        <SelectEditor
                            label="Type"
                            options={EventTypeOptions}
                            selected={filter?.EventType}
                            getText={(v) => {
                                return EventTypeMap[v];
                            }}
                            onChange={(v) => {
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        EventType: v,
                                        EventCategoryId: null,
                                        NotificationId: null,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <SelectEditor
                            label="Category"
                            options={[null].concat(alertDefinitionCategories.map((x) => x.Id))}
                            selected={filter?.EventCategoryId}
                            getText={(v) => {
                                if (v == null) {
                                    return "All";
                                }
                                return alertDefinitionCategories.find((x) => x.Id == v).Name;
                            }}
                            onChange={(v) => {
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        EventCategoryId: v,
                                        NotificationId: null,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <SelectEditor
                            label="Notification"
                            options={[null].concat(notificationOptions.map((x) => x.Id))}
                            getText={(v) => {
                                if (v == null) {
                                    return "All";
                                }
                                return alertDefinitions.find((x) => x.Id == v).Name;
                            }}
                            selected={filter?.NotificationId}
                            onChange={(v) => {
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        NotificationId: v,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className={"control-label"}>
                            <label>Adviser</label>
                        </div>
                        <MultiselectDropdown
                            placeholder={
                                this.state.filter?.AdviserIds?.length == 0 || !this.state.filter?.AdviserIds
                                    ? "Adviser selection"
                                    : this.state.availableAdvisors.length == this.state.filter?.AdviserIds?.length
                                    ? "Adviser selection (All)"
                                    : `Adviser selection (${this.state.filter?.AdviserIds?.length})`
                            }
                            children={
                                <>
                                    <div className="item is-all">
                                        <CheckboxEditor
                                            label={"All"}
                                            disabled={this.state.availableAdvisors.length == 0}
                                            onChange={(v) => {
                                                const data = { ...this.state.filter };
                                                if (v) {
                                                    data.AdviserIds = this.state.availableAdvisors.map(
                                                        (i) => i.AdvisorId
                                                    );
                                                } else {
                                                    data.AdviserIds = [];
                                                }
                                                this.setState({ filter: data });
                                            }}
                                            value={
                                                this.state.availableAdvisors.length == 0 ||
                                                this.state.availableAdvisors.length ==
                                                    this.state.filter?.AdviserIds?.length
                                            }
                                        />
                                    </div>
                                    {(this.state.availableAdvisors || [])?.map((ele) => {
                                        return (
                                            <div className="item">
                                                <CheckboxEditor
                                                    label={ele.Name}
                                                    onChange={(v) => {
                                                        const data = { ...this.state.filter };
                                                        if (v) {
                                                            data.AdviserIds.push(ele.AdvisorId);
                                                        } else {
                                                            data.AdviserIds = data.AdviserIds.filter(
                                                                (item) => item != ele.AdvisorId
                                                            );
                                                        }
                                                        this.setState({ filter: data });
                                                    }}
                                                    value={(this.state.filter?.AdviserIds || []).some(
                                                        (item) => item == ele.AdvisorId
                                                    )}
                                                />
                                            </div>
                                        );
                                    })}
                                </>
                            }
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <TextBoxEditor
                            value={filter?.ClientName}
                            label={"Client name"}
                            maxLength={100}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        ClientName: v,
                                    },
                                })
                            }
                            validationRules={[
                                {
                                    errorMessage: "Please enter at least three characters",
                                    validator: (v) => {
                                        if (v) {
                                            return v.trim().replace(/ +/g, "").length >= 3 ? true : false;
                                        }
                                        return true;
                                    },
                                },
                            ]}
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <TextBoxEditor
                            value={filter?.ClientReference}
                            label={"Client reference/account number"}
                            maxLength={15}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        ClientReference: v,
                                    },
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-4">
                        <SelectEditor
                            label="Follow up"
                            options={[null].concat(true, false)}
                            getText={(v) => {
                                if (v == null) {
                                    return "All";
                                } else if (v) {
                                    return "Yes";
                                } else {
                                    return "No";
                                }
                            }}
                            selected={filter?.FollowUp}
                            onChange={(v) => {
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        FollowUp: v,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <SelectEditor
                            label="Read"
                            options={[null].concat(true, false)}
                            getText={(v) => {
                                if (v == null) {
                                    return "All";
                                } else if (v) {
                                    return "Yes";
                                } else {
                                    return "No";
                                }
                            }}
                            selected={filter?.IsRead}
                            onChange={(v) => {
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        IsRead: v,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-12 col-md-4">
                        <SelectEditor
                            label="Date"
                            options={NotificationDateRangeTypeOptions}
                            selected={filter?.DateRangeOption}
                            getText={(v) => {
                                return NotificationDateRangeTypeMap[v];
                            }}
                            onChange={(v) => {
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        DateRangeOption: v,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        From{" "}
                        {DateHelper.getDateStringAsddmmmyyyy(
                            NotificationFilterStore.calculateFromDate(filter?.DateRangeOption),
                            true
                        )}{" "}
                        until {DateHelper.getDateStringAsddmmmyyyy(new Date(), true)}
                    </div>
                </div>
            </div>
        );
    }
}
